module.exports = __webpack_public_path__ + "img/kaihui.059ab61b.png";